import { createSelector } from 'reselect';

const selectSettlementRequests = (state: any) => state.settlementRequests;


export const selectSettlementRequestCurrentItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.current);

export const selectSettlementRequestsListItems = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.list);

export const selectSettlementRequestItemById = (itemId: any) =>
    createSelector(selectSettlementRequestsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSettlementRequestQueryItems = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.query);

export const selectSettlementRequestCreatedItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.create);

export const selectSettlementRequestUpdatedItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.update);

export const selectSettlementRequestReadItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.read);

export const selectSettlementRequestDeletedItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.delete);

export const selectSettlementRequestSearchedItems = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.search);

export const selectSettlementRequestItemsCount = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.count);

export const selectSettlementRequestItemsFilter = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.filter);

export const selectSettlementRequestTriggerItem = createSelector([selectSettlementRequests], (settlementRequests) => settlementRequests.trigger);
